module.exports = __webpack_public_path__ + "static/media/SignUp.d65ff196.svg";